import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import Box from "../../../components/Box";
import { Helpers } from "../../../helpers/Helpers";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import { storeActivityIndicator, storeFastFirm } from "../../../redux/reducers/authSlice";
import toast from "react-hot-toast";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../components/CustomSingleSelect";
import { ConstantService } from "../../../services/ConstantService";
import { CompanyService } from "../../../services/CompanyService";
import { GetCompanyByIdResponse, GetCompanyByIdResponseCompanyAuthorizedPerson } from "../../../models/response/company/GetCompanyByIdResponse";
import { GetConstantListResponse } from "../../../models/response/constant/GetConstantListResponse";
import { MeetingService } from "../../../services/MeetingService";
import { AddMeetingResponse } from "../../../models/response/meeting/AddMeetingResponse";
import { GetMeetingByIdResponse, GetMeetingByIdResponseAntrepoOffer, GetMeetingByIdResponseFileArchive } from "../../../models/response/meeting/GetMeetingByIdResponse";
import FileArchives from "./Components/FileArchives";
import PageHeader from "../../../components/PageHeader";
import GeneralInformation from "./Components/GeneralInformation";
import ActionButtons from "./Components/ActionButtons";
import AntrepoOffers from "./Components/AntrepoOffers";

const MeetingAdd = () => {
    const navigate = useNavigate();
    const pageName = "Pazarlama > Görüşmeler"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();
    const generalInformationRef: any = useRef();
    const fileArchivesRef: any = useRef();
    const antrepoOffersRef: any = useRef();

    const [meetingId, setMeetingId] = useState<string | undefined>(undefined);
    const [refNo, setRefNo] = useState<string | undefined>(undefined);
    const [selectedCurrentCompany, setSelectedCurrentCompany] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [companyAuthorizedPersons, setCompanyAuthorizedPersons] = useState<GetCompanyByIdResponseCompanyAuthorizedPerson[]>([]);
    const [selectedAuthorizedPerson, setSelectedAuthorizedPerson] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [phoneList, setPhoneList] = useState<CustomSingleSelectModel[]>([]);
    const [selectedPhone, setSelectedPhone] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [emailList, setEmailList] = useState<CustomSingleSelectModel[]>([]);
    const [selectedEmail, setSelectedEmail] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedMeetingType, setSelectedMeetingType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedMeetingRemindReason, setSelectedMeetingRemindReason] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [remindDate, setRemindDate] = useState<string | undefined>(undefined);
    const [note, setNote] = useState<string | undefined>(undefined);

    const [fileArchives, setFileArchives] = useState<GetMeetingByIdResponseFileArchive[]>([]);
    const [antrepoOffers, setAntrepoOffers] = useState<GetMeetingByIdResponseAntrepoOffer[]>([]);

    useEffect(() => {
        var id = searchParams.get("id");
        getData(id);
    }, [])

    const getData = async (_id: string | undefined | null = undefined) => {
        try {
            dispatch(storeActivityIndicator(true));

            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

            if (!id) {
                var response5: GetConstantListResponse = await ConstantService.getConstantList('MEETING_TYPE', undefined, "1");

                if (!response5.isSuccess) {
                    toast.error(response5.message)
                    return;
                }

                if (response5.data.length > 0) {
                    setSelectedMeetingType({ label: response5.data[0].value + '', value: response5.data[0].constantId, additionalValue1: response5.data[0].additionalValue1 });
                }
            }

            if (id) {
                var response: GetMeetingByIdResponse = await MeetingService.getMeetingById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setMeetingId(response.data.meetingId);
                setRefNo(response.data.refNo);

                if (response.data.selectedCompanyId && response.data.selectedCompanyName) {
                    setSelectedCurrentCompany({ label: response.data.selectedCompanyName, value: response.data.selectedCompanyId });

                    var response2: GetCompanyByIdResponse = await CompanyService.getCompanyById(response.data.selectedCompanyId);

                    if (!response2.isSuccess) {
                        toast.error(response2.message)
                        return;
                    }

                    setCompanyAuthorizedPersons(response2.data.companyAuthorizedPersons);

                    var authPerson = response2.data.companyAuthorizedPersons.find(x => x.companyAuthorizedPersonId == response.data.selectedPersonAuthorizedPersonId);

                    if (authPerson) {
                        authorizedPersonSelectHandler({ label: authPerson.name + ' ' + authPerson.surname, value: authPerson.companyAuthorizedPersonId }, response2.data.companyAuthorizedPersons, response.data.selectedPersonAuthorizedPersonPhone, response.data.selectedPersonAuthorizedPersonEmail);
                    }
                }

                if (response.data.meetingTypeId && response.data.meetingTypeName) {
                    setSelectedMeetingType({ label: response.data.meetingTypeName, value: response.data.meetingTypeId });
                }

                if (response.data.meetingRemindReasonId && response.data.meetingRemindReasonName) {
                    setSelectedMeetingRemindReason({ label: response.data.meetingRemindReasonName, value: response.data.meetingRemindReasonId });
                }

                setRemindDate(response.data.meetingRemindDate);

                setNote(response.data.note);

                setFileArchives(response.data.fileArchives);
                setAntrepoOffers(response.data.antrepoOffers);
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const saveMeeting = async () => {
        try {
            if (!selectedCurrentCompany)
                toast.error('Firma Adı alanını doldurunuz!')
            else if (!selectedAuthorizedPerson)
                toast.error('Yetkili Kişi alanını doldurunuz!')
            else if (!selectedPhone)
                toast.error('Yetkili Telefon alanını doldurunuz!')
            else if (!selectedEmail)
                toast.error('Yetkili E-Posta alanını doldurunuz!')
            else if (!selectedMeetingType)
                toast.error('Görüşme Şekli alanını doldurunuz!')
            else if (Helpers.isEmpty(note))
                toast.error('Görüşme Notu alanını doldurunuz!')
            else {
                dispatch(storeActivityIndicator(true));

                var response: AddMeetingResponse = await MeetingService.addMeeting({
                    meetingId: meetingId,
                    meetingRemindDate: remindDate,
                    meetingRemindReasonId: selectedMeetingRemindReason?.value,
                    meetingTypeId: selectedMeetingType.value,
                    note: note,
                    refNo: refNo,
                    selectedCompanyId: selectedCurrentCompany.value,
                    selectedPersonAuthorizedPersonEmail: selectedEmail.value,
                    selectedPersonAuthorizedPersonId: selectedAuthorizedPerson.value,
                    selectedPersonAuthorizedPersonPhone: selectedPhone.value,
                    fileArchives: fileArchives.map(function (x) {
                        return {
                            description: x.description,
                            entityId: x.entityId,
                            file: x.fileArchiveFile,
                            fileName: x.fileName,
                            fileTypeId: x.fileTypeId,
                            fileArchiveId: x.fileArchiveId
                        }
                    })
                });

                if (!response.isSuccess) {
                    toast.error(response.message);
                    dispatch(storeActivityIndicator(false));
                    return;
                }

                toast.success(response.message)
                // navigate('/meeting/listadd?id=' + response.data.meetingId);
                // getData(response.data.meetingId);
                navigate(Helpers.getGoBackUrl())
            }
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    const authorizedPersonSelectHandler = (_selectedAuthorizedPerson: CustomSingleSelectModel | undefined, _list: GetCompanyByIdResponseCompanyAuthorizedPerson[] | undefined = undefined, phoneToBeSet: string | undefined = undefined, emailToBeSet: string | undefined = undefined) => {
        setSelectedAuthorizedPerson(_selectedAuthorizedPerson);

        if (_selectedAuthorizedPerson) {
            var person = (_list ? _list : companyAuthorizedPersons).find(x => x.companyAuthorizedPersonId == _selectedAuthorizedPerson.value);

            if (person) {
                var phoneList = [];

                if (!Helpers.isEmpty(person.phone1))
                    phoneList.push(person.phone1);

                if (!Helpers.isEmpty(person.phone2))
                    phoneList.push(person.phone2);

                setPhoneList(phoneList.map(function (x) {
                    return { label: x + '', value: x + '' }
                }));

                if (phoneToBeSet) {
                    setSelectedPhone({ label: phoneToBeSet, value: phoneToBeSet });
                }
                else {
                    if (phoneList.length == 1)
                        setSelectedPhone({ label: phoneList[0] + '', value: phoneList[0] + '' });
                    else
                        setSelectedPhone(undefined);
                }

                var emailList = [];

                if (!Helpers.isEmpty(person.email))
                    emailList.push(person.email);

                setEmailList(emailList.map(function (x) {
                    return { label: x + '', value: x + '' }
                }));

                if (emailToBeSet) {
                    setSelectedEmail({ label: emailToBeSet, value: emailToBeSet });
                }
                else {
                    if (emailList.length == 1)
                        setSelectedEmail({ label: emailList[0] + '', value: emailList[0] + '' });
                    else
                        setSelectedEmail(undefined);
                }

                return;
            }
        }

        setSelectedPhone(undefined);
        setSelectedEmail(undefined);
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={
                <ActionButtons
                    meetingId={meetingId}
                />
            } />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <PageHeader
                        items={[
                            { text: 'Genel Bilgiler', ref: generalInformationRef },
                            { text: 'Bağlı Teklifler', ref: antrepoOffersRef },
                            { text: 'Dijital Arşiv', ref: fileArchivesRef },
                        ]}
                    />

                    <GeneralInformation
                        authorizedPersonSelectHandler={authorizedPersonSelectHandler}
                        companyAuthorizedPersons={companyAuthorizedPersons}
                        emailList={emailList}
                        generalInformationRef={generalInformationRef}
                        note={note}
                        phoneList={phoneList}
                        refNo={refNo}
                        remindDate={remindDate}
                        selectedAuthorizedPerson={selectedAuthorizedPerson}
                        selectedCurrentCompany={selectedCurrentCompany}
                        selectedEmail={selectedEmail}
                        selectedMeetingRemindReason={selectedMeetingRemindReason}
                        selectedMeetingType={selectedMeetingType}
                        selectedPhone={selectedPhone}
                        setCompanyAuthorizedPersons={setCompanyAuthorizedPersons}
                        setEmailList={setEmailList}
                        setNote={setNote}
                        setPhoneList={setPhoneList}
                        setRefNo={setRefNo}
                        setRemindDate={setRemindDate}
                        setSelectedAuthorizedPerson={setSelectedAuthorizedPerson}
                        setSelectedCurrentCompany={setSelectedCurrentCompany}
                        setSelectedEmail={setSelectedEmail}
                        setSelectedMeetingRemindReason={setSelectedMeetingRemindReason}
                        setSelectedMeetingType={setSelectedMeetingType}
                        setSelectedPhone={setSelectedPhone}
                    />

                    <AntrepoOffers
                        antrepoOffers={antrepoOffers}
                        antrepoOffersRef={antrepoOffersRef}
                    />

                    <FileArchives
                        fileArchives={fileArchives}
                        fileArchivesRef={fileArchivesRef}
                        setFileArchives={setFileArchives}
                    />

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">

                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={saveMeeting}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment >
    )
}

export default MeetingAdd;